import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../../../colors';
import {
  FOOTER_HEIGHT
} from '../../../../../components/shared/make-reservation/components/footer-booking/footer-booking.styled';

export const EventsListReservationStyled = {
  Container: styled(Grid)<any>`
    margin-bottom: calc(${FOOTER_HEIGHT}px + 20px);
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.White} ;
    padding: 20px 31px 20px 31px;
  `,
  ContainerHeader: styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  ContainerHeaderTitle: styled.p`
    font-size: 16px;
    color: ${Colors.Black};
    font-family: EncodeSans-SemiBold;
    letter-spacing: 1px;
  `,
  ContainerContent: styled.div<any>`
    margin-top: 16px;
  `,
  ContainerContentModal: styled.div<any>`
    background-color: ${Colors.White};
    min-width: 200px;
    min-height: 250px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  `,
  ContainerDateTime: styled.div<any>``,
  TitleModalDateTime: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 17px;
    margin-bottom: 10px;
  `,
  ErrorMessageDateTime: styled.p<any>`
    margin-top: 5px;
    font-family: EncodeSans-Regular;
    font-size: 14px;
    color: ${Colors.Red};
  `,
};
